<template>
  <div>
    <mdb-container class="mt-5 content-area mt-5">
      <PageHeader text="Dashboard"></PageHeader>

      <div class="d-flex justify-content-center mt-5" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="mt-5" v-if="!isLoading">
        <mdb-alert v-if="showAlert" class="d-flex justify-content-center" color="danger">
          <b>Oh no,</b> it looks like you have not granted all required permission. Please grant the following permissions:
        </mdb-alert>

        <h5>Hey {{user.firstName}}!</h5>
        <p class="mb-0">Welcome to our beta 2.0. We did some great changes to virallyze.</p>
        <p
          class="mb-0"
        >For example you dont need to connect your facebook account anymore (but you still can, to use virallyze cheaper).</p>
        <p class="mb-0">We have also did some changes to the ui.</p>
        <p class="mb-0">
          If you have any questions please contact us at
          <a
            href="mailto://info@virallyze.com"
          >info@virallyze.com</a>
        </p>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer, mdbAlert } from "mdbvue";
import PageHeader from "../../components/PageHeader";
export default {
  name: "Dashboard",
  components: {
    mdbContainer,
    mdbAlert,
    PageHeader
  },
  computed: {
    isLoading: function() {
      return "";
    },
    user: function() {
      return this.$store.getters["user/user"];
    }
  },
  methods: {},
  data() {
    return {
      showAlert: false
    };
  },
  created: function() {}
};
</script>
